export default "__VITE_ASSET__B2sP2lbD__"